// extracted by mini-css-extract-plugin
export default {"button":"hoverlistitem_button__y8T3t","text":"hoverlistitem_text__SML8O","logo":"hoverlistitem_logo__Qu3+i"};